import { render, staticRenderFns } from "./ModalMotivoSolicitud.vue?vue&type=template&id=08d1c12c&scoped=true&"
import script from "./ModalMotivoSolicitud.vue?vue&type=script&lang=js&"
export * from "./ModalMotivoSolicitud.vue?vue&type=script&lang=js&"
import style0 from "./ModalMotivoSolicitud.vue?vue&type=style&index=0&id=08d1c12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d1c12c",
  null
  
)

export default component.exports